import React, { useState } from "react";
import { Button, TextField, Typography } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import {
  convertPresetsToDb,
  isTimeOverlapping,
  handleAddSchedule,
} from "./utils";
import TimeSlotList from "./TimeSlotList";
import * as S from "./styles";
import { SaveButton, CancelButton } from "../../common/Buttons";

function NewPresetForm({
  createMutation,
  setIsCreating,
  openSnackbar,
  group_code,
  project_code,
  shiftsData,
}) {
  const [newPreset, setNewPreset] = useState({
    name: "",
    description: "",
    schedules: [
      {
        id: Date.now(),
        start: "09:00",
        end: "18:00",
        isUntilMidnight: false,
        shift_id: "",
      },
    ],
  });
  const handleSaveNewPreset = () => {
    if (!newPreset.name.trim()) {
      openSnackbar("프리셋 이름을 입력해주세요.", "info");
      return;
    }
    const timeValidation = isTimeOverlapping(newPreset.schedules);
    if (!timeValidation.isValid) {
      openSnackbar(timeValidation.message, "error");
      return;
    }
    // 모든 schedule에 shift_id가 있는지 검사
    const hasInvalidShiftId = newPreset.schedules.some(
      (schedule) =>
        !schedule.shift_id ||
        schedule.shift_id === "" ||
        schedule.shift_id === undefined
    );
    if (hasInvalidShiftId) {
      openSnackbar("모든 시간 구간에 조업 구분을 선택해주세요.", "error");
      return;
    }
    createMutation.mutate(
      { data: convertPresetsToDb(newPreset), group_code, project_code },
      {
        onSuccess: () => {
          openSnackbar("새로운 프리셋을 저장하였습니다.");
          setIsCreating(false);
        },
        onError: (e) => {
          toast.error(e.response.data.message);
        },
      }
    );
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
    >
      <S.PresetForm elevation={3}>
        <Typography variant="h6" gutterBottom>
          근무시간 유형 등록
        </Typography>
        <div style={{ display: "flex", gap: "1rem" }}>
          <TextField
            label="근무시간 유형 이름"
            sx={{ width: "40%" }}
            value={newPreset.name}
            onChange={(e) =>
              setNewPreset({ ...newPreset, name: e.target.value })
            }
            margin="normal"
            size="small"
          />
          <TextField
            label="메모"
            sx={{ width: "60%" }}
            value={newPreset.description}
            onChange={(e) =>
              setNewPreset({
                ...newPreset,
                description: e.target.value,
              })
            }
            margin="normal"
            size="small"
          />
        </div>
        <TimeSlotList
          preset={newPreset}
          setPreset={setNewPreset}
          shiftsData={shiftsData}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "1rem",
          }}
        >
          <Button
            startIcon={<AddIcon />}
            onClick={() => handleAddSchedule(newPreset, setNewPreset)}
            color="primary"
          >
            시간 추가
          </Button>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <SaveButton onClick={handleSaveNewPreset} />
            <CancelButton onClick={() => setIsCreating(false)} />
          </div>
        </div>
      </S.PresetForm>
    </motion.div>
  );
}

export default NewPresetForm;
